/**
 * Utility to manage offline data persistence for GastroFlow.
 * This helps the restaurant to keep seeing orders and commands even when offline.
 */

const STORAGE_KEYS = {
  ORDERS: 'gastroflow_persistent_orders',
  TABLE_COMMANDS: 'gastroflow_persistent_table_commands',
  PRINTER_CONFIGS: 'gastroflow_persistent_printer_configs',
  METRICS: 'gastroflow_persistent_metrics',
  RESERVATIONS: 'gastroflow_persistent_reservations',
  MENU: 'gastroflow_persistent_menu',
  PRINTERS: 'gastroflow_persistent_printers',
  LAST_SYNC: 'gastroflow_last_sync_timestamp',



};

export const persistence = {
  /**
   * Saves a dataset to localStorage
   */
  save: (key: keyof typeof STORAGE_KEYS, data: any) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(STORAGE_KEYS[key], serializedData);
      
      if (key === 'ORDERS' || key === 'TABLE_COMMANDS') {
        localStorage.setItem(STORAGE_KEYS.LAST_SYNC, new Date().toISOString());
      }
    } catch (error) {
      console.error(`Error saving to persistence (${key}):`, error);
    }
  },

  /**
   * Loads a dataset from localStorage
   */
  load: <T>(key: keyof typeof STORAGE_KEYS): T | null => {
    try {
      const serializedData = localStorage.getItem(STORAGE_KEYS[key]);
      if (!serializedData) return null;
      return JSON.parse(serializedData) as T;
    } catch (error) {
      console.error(`Error loading from persistence (${key}):`, error);
      return null;
    }
  },

  /**
   * Gets the last sync timestamp
   */
  getLastSync: (): string | null => {
    return localStorage.getItem(STORAGE_KEYS.LAST_SYNC);
  },

  /**
   * Clears all persistent data
   */
  clear: () => {
    Object.values(STORAGE_KEYS).forEach(key => localStorage.removeItem(key));
  }
};
